/**
 * @flow
 * Created by neo on 13.03.17.
 */
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import BookingRequest from '../../../Store/Booking/BookingRequest';
import { Input, Label } from 'reactstrap';
import { FlightOfferAircraft } from '../../../Store/FlightOffer';
import { t } from 'i18next';

type Props = {
  booking: BookingRequest,
  onAircraftChanged: (aircraft: FlightOfferAircraft) => void
};

@observer
export default class AircraftSelect extends Component {

  props: Props;

  selectAircraft = (aircraftOfferId: string) => {
    this.props.booking.aircraft = new FlightOfferAircraft(this.props.booking.flightOffer.aircraft_offers.find(a => a.id == aircraftOfferId));
    this.props.onAircraftChanged(this.props.booking.aircraft);
  };

  getAircraftMedia() {
    if(this.props.booking.aircraft && this.props.booking.aircraft.aircraft_model.files && this.props.booking.aircraft.aircraft_model.files.length > 0) {
      return this.props.booking.aircraft.aircraft_model.files[0].file.url;
    }
    return null;
  }

  render() {

    if(this.props.booking.aircraft) {
      const media = this.getAircraftMedia();

      let mediaTag = null;
      if(media) {
        const imageStyle = { backgroundImage: `url('${media}')` };

        mediaTag = (
          <div className="mt-2 mb-4">
            <div className="image" style={imageStyle}></div>
          </div>
        );
      }

      return (
        <div className="aircraft-select">
          {mediaTag}
          <Label>1. {t('Flugzeug')}</Label>
          <Input type="select" bsSize="sm" value={this.props.booking.aircraft.id} onChange={e => this.selectAircraft(e.target.value)}>
            {this.props.booking.flightOffer.aircraft_offers.map((a, i) => {
              return (
                <option key={i} value={a.id}>{a.aircraft_model.name}</option>
              )
            })}
          </Input>
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/Booking/AircraftSelect.js